export interface User
{
};

export interface Token
{
    accessToken: string;
    expires: string;
};

export const Storage = {
    user:
    {
        set: (user: User) => localStorage.setItem('@MomentaMais/user',  JSON.stringify(user)),
        get: () => { return JSON.parse(localStorage.getItem('@MomentaMais/user') as string) as User || null; },
    },
    token:
    {
        set: (token: Token) => localStorage.setItem('@MomentaMais/token',  JSON.stringify(token)),
        get: () => { return JSON.parse(localStorage.getItem('@MomentaMais/token') as string) as Token || null; },
    }
};

export default Storage;